@if (showSplashAnimation) {
  <ui-splash-screen (animationDone)="onSplashScreenAnimationDone()"></ui-splash-screen>
}

<ui-shell></ui-shell>
